import CustomEvents, { Events } from '@client/core/CustomEvents';
import PageHandler, { HistoryState } from '@client/core/PageSwitch/PageHandler';
import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';

export const getQueryFromLocation = () => {
	// if (typeof window === undefined) return;
	// const url = new URL(window.location.href);
	const url = new URL(PageHandler.getInstance().currentUrl, 'https://example.com');
	// console.log('getQueryFromLocation', url.searchParams.get('q'));
	return url.searchParams.get('q')?.trim();
};

export const useSearchQuery = (): [string | undefined, Dispatch<SetStateAction<string | undefined>>] => {
	const [query, setQuery] = useState<string | undefined>(undefined);
	const [ready, setReady] = useState(false);

	useEffect(() => {
		const handlePopState = (ev: CustomEvent<string>) => {
			setQuery(getQueryFromLocation());
		};

		CustomEvents.listen(Events.SAMEPAGE, handlePopState);
		setQuery(getQueryFromLocation());
		setReady(true);

		return () => {
			CustomEvents.remove(Events.SAMEPAGE, handlePopState);
		};
	}, []);

	// useEffect(() => {
	// 	const handlePopState = (ev: PopStateEvent) => {
	// 		console.log('setQuery', getQueryFromLocation(), ev);
	// 		setQuery(getQueryFromLocation());
	// 	};

	// 	window.addEventListener('popstate', handlePopState);
	// 	console.log('hookQuery', getQueryFromLocation());
	// 	setQuery(getQueryFromLocation());

	// 	return () => {
	// 		window.removeEventListener('popstate', handlePopState);
	// 	};
	// }, []);

	useEffect(() => {
		if (!ready) return;
		const val = query?.trim();
		if (getQueryFromLocation() !== val) {
			const url = new URL(window.location.href);
			if (val === undefined) {
				url.searchParams.delete('q');
			} else {
				url.searchParams.set('q', val);
			}
			// window.history.replaceState({}, '', url);
			PageHandler.getInstance().goto(url.toString(), HistoryState.REPLACE);
		}
	}, [query, ready]);

	return [query, setQuery];
};
